// TODO @Riyadh
export async function holdTimeslots(timeslotId: number, count: number) {
  console.log(timeslotId + count);

  return;
}

export async function holdRetails(retailOptionId: number, count: number) {
  console.log(retailOptionId + count);

  return;
}
